module.exports = __webpack_public_path__ + "img/22.916c1c8f.png";